/***
 * @file:ç©¿æ¢­æ¡
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
// import { takeUntil } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { Observable, of, Subject } from 'rxjs';

import { InputBoolean } from '@ithinkdt/shared/utils';
import { TransferListComponent } from './transfer-list/transfer-list.component';
import {
  TransferCanMove,
  TransferChange,
  TransferItem,
  TransferList,
  TransferSearchChange,
  TransferSelectChange,
} from './transfer.interface';

@Component({
  selector: 'dt-transfer',
  preserveWhitespaces: false,
  templateUrl: './transfer.component.html',
  host: {
    '[class.ant-transfer]': 'true',
    '[class.ant-transfer-disabled]': 'nzDisabled',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferComponent implements OnInit, OnChanges, OnDestroy {
  // #endregion

  constructor(private cdr: ChangeDetectorRef) {}
  private unsubscribe$ = new Subject<void>();
  @ViewChildren(TransferListComponent)
  private lists: QueryList<TransferListComponent>;
  // tslint:disable-next-line:no-any
  locale: any = {
    notFoundContent: 'nomatchingResult',
    searchPlaceholder: 'pleaseInputContent',
    itemUnit: 'defaultValue.item',
    itemsUnit: 'defaultValue.item',
  };

  leftFilter = '';
  rightFilter = '';

  // #region fields

  @Input() @InputBoolean() nzDisabled = false;
  @Input() nzDataSource: TransferList = {};
  @Input() nzTitles: string[] = ['', ''];
  @Input() nzOperations: string[] = [];
  @Input() nzListStyle: object;
  @Input() nzItemUnit: string;
  @Input() nzItemsUnit: string;
  @Input() nzRender: TemplateRef<void>;
  @Input() nzFooter: TemplateRef<void>;
  @Input() @InputBoolean() nzShowSearch = false;
  @Input() nzFilterOption: (inputValue: string, item: TransferItem) => boolean;
  @Input() nzSearchPlaceholder: string;
  @Input() nzNotFoundContent: string;

  // events
  @Output() readonly nzChange: EventEmitter<TransferChange> = new EventEmitter();
  @Output() readonly nzSearchChange: EventEmitter<TransferSearchChange> = new EventEmitter();
  @Output() readonly nzSelectChange: EventEmitter<TransferSelectChange> = new EventEmitter();

  // lists id
  allDropLists = [String(new Date().getTime()), String(new Date().getTime() + 1)];
  // left
  leftDataSource: TransferItem[] = [];
  // right
  rightDataSource: TransferItem[] = [];

  leftActive = false;
  rightActive = false;
  @Input() nzCanMove: (arg: TransferCanMove) => Observable<TransferItem[]> = (arg: TransferCanMove) => of(arg.list);

  // æå¨æ¹å
  onDragChange(data) {
    this.leftDataSource = cloneDeep(this.leftDataSource);
    this.rightDataSource = cloneDeep(this.rightDataSource);
    const datas = {
      left: this.leftDataSource,
      right: this.rightDataSource,
    };
    this.nzChange.emit({
      from: data.from,
      to: data.to,
      list: data.list,
      datas,
    });
    this.markForCheckAllList();

    // console.log("data.list",data.list)
    // this.moveTo(data.to);
  }

  // å¨é¨åè¡¨æ°æ®
  // get allList(){
  //   return [...this.leftDataSource, this.rightDataSource];
  // }

  private splitDataSource(): void {
    this.leftDataSource = [];
    this.rightDataSource = [];
    this.nzDataSource = cloneDeep(this.nzDataSource) || {};
    // this.nzDataSource.forEach(record => {
    //   if (record.direction === 'right') {
    //     this.rightDataSource.push(record);
    //   } else {
    //     this.leftDataSource.push(record);
    //   }
    // });
    this.leftDataSource = this.nzDataSource['left'] || [];
    this.rightDataSource = this.nzDataSource['right'] || [];
  }

  private getCheckedData(direction: string): TransferItem[] {
    return this[direction === 'left' ? 'leftDataSource' : 'rightDataSource'].filter((w) => w.checked);
  }

  handleLeftSelectAll = (checked: boolean) => this.handleSelect('left', checked);
  handleRightSelectAll = (checked: boolean) => this.handleSelect('right', checked);

  handleLeftSelect = (item: TransferItem) => this.handleSelect('left', item.checked, item);
  handleRightSelect = (item: TransferItem) => this.handleSelect('right', item.checked, item);

  handleSelect(direction: 'left' | 'right', checked: boolean, item?: TransferItem): void {
    const list = this.getCheckedData(direction);
    this.updateOperationStatus(direction, list.length);
    this.nzSelectChange.emit({ direction, checked, list, item });
  }

  handleFilterChange(ret: { direction: string; value: string }): void {
    this.nzSearchChange.emit(ret);
  }

  private updateOperationStatus(direction: string, count?: number): void {
    this[direction === 'right' ? 'leftActive' : 'rightActive'] =
      (typeof count === 'undefined' ? this.getCheckedData(direction).filter((w) => !w.disabled).length : count) > 0;
  }

  moveToLeft = () => this.moveTo('left');
  moveToRight = () => this.moveTo('right');

  moveTo(direction: string): void {
    const oppositeDirection = direction === 'left' ? 'right' : 'left';
    this.updateOperationStatus(oppositeDirection, 0);
    const datasource = direction === 'left' ? this.rightDataSource : this.leftDataSource;
    const moveList = datasource.filter((item) => item.checked === true && !item.disabled);
    this.nzCanMove({ direction, list: moveList }).subscribe(
      (newMoveList) => this.truthMoveTo(direction, newMoveList.filter((i) => !!i)),
      () => moveList.forEach((i) => (i.checked = false))
    );
  }

  private truthMoveTo(direction: string, list: TransferItem[]): void {
    const oppositeDirection = direction === 'left' ? 'right' : 'left';
    const datasource = direction === 'left' ? this.rightDataSource : this.leftDataSource;
    const targetDatasource = direction === 'left' ? this.leftDataSource : this.rightDataSource;
    for (const item of list) {
      item.checked = false;
      targetDatasource.push(item);
      datasource.splice(datasource.indexOf(item), 1);
    }
    this.updateOperationStatus(oppositeDirection);
    const datas = {
      left: this.leftDataSource,
      right: this.rightDataSource,
    };
    this.nzChange.emit({
      from: oppositeDirection,
      to: direction,
      list,
      datas,
    });
    this.markForCheckAllList();
  }

  private markForCheckAllList(): void {
    if (!this.lists) {
      return;
    }
    this.lists.forEach((i) => i.markForCheck());
  }

  ngOnInit(): void {
    // this.i18n.localeChange.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
    //   this.locale = this.i18n.getLocaleData('Transfer');
    //   this.markForCheckAllList();
    // });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('nzDataSource' in changes) {
      this.splitDataSource();
      this.updateOperationStatus('left');
      this.updateOperationStatus('right');
      this.cdr.detectChanges();
      this.markForCheckAllList();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
